import { fetchGET } from '@enuan/m3mgr-utils';
import {
	adaptUsersConfiguration,
	IConfiguration,
	logError,
} from '@enuan/chat__utils';

/**
 * Fetches the runtime configuration JSON from the widget base URL and
 * normalises the avatar configuration by applying `adaptUsersConfiguration`
 * on the `chat` slice.
 *
 * Uses `fetchGET` from `@enuan/m3mgr-utils` for consistent HTTP handling
 * across the platform. Credentials are forwarded via the `getOptions` callback
 * so cross-site deployments that require cookies continue to work.
 *
 * @param baseUrl - Base URL of the widget; `config/config.json` is resolved
 * relative to it.
 * @returns The normalised `IConfiguration` ready for use in the context.
 */
export const fetchConfiguration = (
	baseUrl: string,
): Promise<IConfiguration> => {
	const withCredentials = process.env.REACT_APP_FETCH_CREDENTIALS === 'true';
	const credentials: RequestCredentials = withCredentials ? 'include' : 'omit';
	const url = new URL('./config/config.json', baseUrl).href;

	return fetchGET<IConfiguration>(url, undefined, (opts) => ({
		...opts,
		credentials,
	}))
		.then((config) =>
			config.chat
				? { ...config, chat: adaptUsersConfiguration(config.chat) }
				: config,
		)
		.catch((error) => {
			logError(
				'configuration:fetch',
				{ error, payload: { url, credentials } },
				{ baseUrl },
			);
			throw error;
		});
};
